/* eslint-disable */
<template>
  <div class="p-6 max-w-4xl mx-auto bg-white rounded-lg shadow-md">
    <div class="flex justify-end mb-6">
      <img :src="logo" alt="Logo" class="h-15 w-20 object-contain" />
    </div>
    <h2 class="flex justify-center text-3xl font-bold mb-4 uppercase">Jamii Plus Comparison quote</h2>

    <form @submit.prevent="addEntry">
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <!-- Member Name -->
        <div>
          <label for="memberName" class="block text-gray-700">Member Name</label>
          <input v-model="form.memberName" id="memberName" type="text" class="mt-1 p-2 border rounded w-full" required />
        </div>

        <!-- DOB -->
        <div>
          <label for="dob" class="block text-gray-700">Date of Birth</label>
          <input v-model="form.dob" id="dob" type="date" class="mt-1 p-2 border rounded w-full" required :max="maxDate"/>
        </div>

        <!-- Gender -->
        <div>
          <label for="gender" class="block text-gray-700">Gender</label>
          <select v-model="form.gender" id="gender" class="mt-1 p-2 border rounded w-full" required>
            <option value="M">Male</option>
            <option value="F">Female</option>
          </select>
        </div>

        <!-- Relationship -->
        <div>
          <label for="relationship" class="block text-gray-700">Relationship</label>
          <select v-model="form.relationship" id="relationship" class="mt-1 p-2 border rounded w-full" required>
            <!-- <option value="Principal">Principal</option> -->
            <option v-if="shouldIncludeOption('Principal')" value="Principal">Principal</option>
            <option v-if="entries.length > 0 && shouldIncludeOption('Spouse')" value="Spouse">Spouse</option>
            <option v-if="entries.length > 0" value="Child">Child</option>
          </select>
        </div>

        <!-- Submit Button -->
        <div class="col-span-2">
          <button type="submit" class="w-full bg-blue-500 text-white p-2 rounded">Add Entry</button>
        </div>
      </div>
    </form>
  </div>
    <!---begin of pdf report -->
  <div id="pdfReport">
    <div class="p-6 mx-auto bg-white rounded-lg shadow-md" ref="reportContent">
        <div class="flex justify-end mb-6">
        <img :src="logo" alt="Logo" class="h-15 w-20 object-contain" />
        </div>
        <div class="flex justify-around">
        <span>Name: {{ this.clientDetails.name }}</span>
        <span>Email: {{ this.clientDetails.email }}</span>
        <span>Mobile: {{ this.clientDetails.phone }}</span>
        <span>Intermediary: {{ this.clientDetails.intermediary }}</span>
        </div>

        <!-- Results Table -->
        <!-- Inpatient Benefits Table -->
        <div v-if="entries.length" class="mt-6">
        <div class="overflow-x-auto">
            <table class="w-full border-collapse border border-gray-300 md:table">
                <thead class="text-center">
                    <tr class="bg-gray-200">
                        <th></th>
                        <th class="border border-gray-300 p-2">Member Name</th>
                        <th class="border border-gray-300 p-2">DOB</th>
                        <th class="border border-gray-300 p-2">Age</th>
                        <th class="border border-gray-300 p-2">Gender</th>
                        <th class="border border-gray-300 p-2">Relationship</th>
                        <th class="border border-gray-300 p-2">
                            <select v-model="form.inpatientBenefits.benefit1" class="mt-1 p-2 border rounded w-full">
                                <option v-for="amount in inpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                            </select>
                        </th>
                        <th class="border border-gray-300 p-2">
                            <select v-model="form.inpatientBenefits.benefit2" class="mt-1 p-2 border rounded w-full">
                                <option v-for="amount in inpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                            </select>
                        </th>
                        <th class="border border-gray-300 p-2">
                            <select v-model="form.inpatientBenefits.benefit3" class="mt-1 p-2 border rounded w-full">
                                <option v-for="amount in inpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                            </select>
                        </th>
                        <th class="border border-gray-300 p-2">
                            <select v-model="form.inpatientBenefits.benefit4" class="mt-1 p-2 border rounded w-full">
                                <option v-for="amount in inpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                            </select>
                        </th>
                        <th class="border border-gray-300 p-2">
                            <select v-model="form.inpatientBenefits.benefit5" class="mt-1 p-2 border rounded w-full">
                                <option v-for="amount in inpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                            </select>
                        </th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="entry in entries" :key="entry.entry_id" class="text-center">
                        <td class="border border-gray-300 p-2">
                            <button
                            @click="deleteEntry(entry.entry_id)"
                            :disabled="isDeleteDisabled(entry.relationship)"
                            class="text-red-500 hover:text-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                            </button>
                        </td>
                        <td class="border border-gray-300 p-2">{{ entry.memberName }}</td>
                        <td class="border border-gray-300 p-2">{{ entry.dob }}</td>
                        <td class="border border-gray-300 p-2">{{ entry.age }}</td>
                        <td class="border border-gray-300 p-2">{{ entry.gender }}</td>
                        <td class="border border-gray-300 p-2">{{ entry.relationship }}</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateInpatientBasedOnBenefit('benefit1', entry)) }}</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateInpatientBasedOnBenefit('benefit2', entry)) }}</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateInpatientBasedOnBenefit('benefit3', entry)) }}</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateInpatientBasedOnBenefit('benefit4', entry)) }}</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateInpatientBasedOnBenefit('benefit5', entry)) }}</td>
                    </tr>
                    <tr class="font-bold text-center">
                        <td class="border border-gray-300 p-2" colspan="6">TOTAL INPATIENT PREMIUM</td>
                        <td class="border border-gray-300 p-2"> {{ formatAmount(totalInpatientBenefits.benefit1) }} </td>
                        <td class="border border-gray-300 p-2"> {{ formatAmount(totalInpatientBenefits.benefit2) }} </td>
                        <td class="border border-gray-300 p-2"> {{ formatAmount(totalInpatientBenefits.benefit3) }} </td>
                        <td class="border border-gray-300 p-2"> {{ formatAmount(totalInpatientBenefits.benefit4) }} </td>
                        <td class="border border-gray-300 p-2"> {{ formatAmount(totalInpatientBenefits.benefit5) }}</td>
                    </tr>

                </tbody>
            </table>
        </div>
        </div>
        <br>

        <!-- Outpatient Benefits Table -->
        <div v-if="entries.length" class="mt-6">
        <div class="overflow-x-auto">
            <table class="w-full border-collapse border border-gray-300 md:table">
                <thead class="text-center">
                    <tr class="bg-gray-200">
                        <th></th>
                        <th class="border border-gray-300 p-2">Member Name</th>
                        <th class="border border-gray-300 p-2">DOB</th>
                        <th class="border border-gray-300 p-2">Age</th>
                        <th class="border border-gray-300 p-2">Gender</th>
                        <th class="border border-gray-300 p-2">Relationship</th>
                        <th class="border border-gray-300 p-2">
                            <select v-model="form.outpatientBenefits.benefit1" class="mt-1 p-2 border rounded w-full" >
                                <option v-for="amount in outpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                            </select>
                        </th>
                        <th class="border border-gray-300 p-2">
                            <select v-model="form.outpatientBenefits.benefit2" class="mt-1 p-2 border rounded w-full" >
                                <option v-for="amount in outpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                            </select>
                        </th>
                        <th class="border border-gray-300 p-2">
                            <select v-model="form.outpatientBenefits.benefit3" class="mt-1 p-2 border rounded w-full" >
                                <option v-for="amount in outpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                            </select>
                        </th>
                        <th class="border border-gray-300 p-2">
                            <select v-model="form.outpatientBenefits.benefit4" class="mt-1 p-2 border rounded w-full" >
                                <option v-for="amount in outpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                            </select>
                        </th>
                        <th class="border border-gray-300 p-2">
                            <select v-model="form.outpatientBenefits.benefit5" class="mt-1 p-2 border rounded w-full" >
                                <option v-for="amount in outpatientAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                            </select>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="entry in entries" :key="entry.entry_id" class="text-center">
                        <td class="border border-gray-300 p-2">
                            <button
                            @click="deleteEntry(entry.entry_id)"
                            :disabled="isDeleteDisabled(entry.relationship)"
                            class="text-red-500 hover:text-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                            </button>
                        </td>
                        <td class="border border-gray-300 p-2">{{ entry.memberName }}</td>
                        <td class="border border-gray-300 p-2">{{ entry.dob }}</td>
                        <td class="border border-gray-300 p-2">{{ entry.age }}</td>
                        <td class="border border-gray-300 p-2">{{ entry.gender }}</td>
                        <td class="border border-gray-300 p-2">{{ entry.relationship }}</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateOutpatientBasedOnBenefit('benefit1', entry)) }}</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateOutpatientBasedOnBenefit('benefit2', entry)) }}</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateOutpatientBasedOnBenefit('benefit3', entry)) }}</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateOutpatientBasedOnBenefit('benefit4', entry)) }}</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateOutpatientBasedOnBenefit('benefit5', entry)) }}</td>
                    </tr>
                    <tr class="font-bold text-center">
                        <td class="border border-gray-300 p-2" colspan="6">TOTAL OUTPATIENT PREMIUM</td>
                        <td class="border border-gray-300 p-2"> {{ formatAmount(totalOutpatientBenefits.benefit1) }} </td>
                        <td class="border border-gray-300 p-2"> {{ formatAmount(totalOutpatientBenefits.benefit2) }} </td>
                        <td class="border border-gray-300 p-2"> {{ formatAmount(totalOutpatientBenefits.benefit3) }} </td>
                        <td class="border border-gray-300 p-2"> {{ formatAmount(totalOutpatientBenefits.benefit4) }} </td>
                        <td class="border border-gray-300 p-2"> {{ formatAmount(totalOutpatientBenefits.benefit5) }}</td>
                    </tr>

                </tbody>
            </table>
        </div>
        </div>
        <br>

        <!-- Maternity Benefits Table -->
        <div v-if="entries.length" class="mt-6">
        <div class="overflow-x-auto">
            <table class="w-full border-collapse border border-gray-300 md:table">
                <thead>
                    <tr class="bg-gray-200">
                    <th class="border border-gray-300 p-2" colspan="5">MATERNITY BENEFIT</th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.maternityBenefits.benefit1" class="mt-1 p-2 border rounded w-full" >
                            <option v-for="amount in maternityAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.maternityBenefits.benefit2" class="mt-1 p-2 border rounded w-full" >
                            <option v-for="amount in maternityAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.maternityBenefits.benefit3" class="mt-1 p-2 border rounded w-full" >
                            <option v-for="amount in maternityAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.maternityBenefits.benefit4" class="mt-1 p-2 border rounded w-full" >
                            <option v-for="amount in maternityAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.maternityBenefits.benefit5" class="mt-1 p-2 border rounded w-full" >
                            <option v-for="amount in maternityAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="border border-gray-300 p-2 font-bold text-center" colspan="5" style="width:40%">TOTAL MATERNITY PREMIUM</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateMaternityBasedOnBenefit('benefit1')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateMaternityBasedOnBenefit('benefit2')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateMaternityBasedOnBenefit('benefit3')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateMaternityBasedOnBenefit('benefit4')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateMaternityBasedOnBenefit('benefit5')) }} </td>
                    </tr>

                </tbody>
            </table>
        </div>
        </div>
        <br>

        <!-- Dental Benefits Table -->
        <div v-if="entries.length" class="mt-6">
        <div class="overflow-x-auto">
            <table class="w-full border-collapse border border-gray-300 md:table">
                <thead>
                    <tr class="bg-gray-200">
                    <th class="border border-gray-300 p-2" colspan="5">DENTAL BENEFIT</th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.dentalBenefits.benefit1" class="mt-1 p-2 border rounded w-full">
                            <option v-for="amount in dentalAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.dentalBenefits.benefit2" class="mt-1 p-2 border rounded w-full">
                            <option v-for="amount in dentalAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.dentalBenefits.benefit3" class="mt-1 p-2 border rounded w-full">
                            <option v-for="amount in dentalAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.dentalBenefits.benefit4" class="mt-1 p-2 border rounded w-full">
                            <option v-for="amount in dentalAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.dentalBenefits.benefit5" class="mt-1 p-2 border rounded w-full">
                            <option v-for="amount in dentalAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="border border-gray-300 p-2 font-bold text-center" colspan="5" style="width:40%">TOTAL DENTAL PREMIUM</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateDentalBasedOnBenefit('benefit1')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateDentalBasedOnBenefit('benefit2')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateDentalBasedOnBenefit('benefit3')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateDentalBasedOnBenefit('benefit4')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateDentalBasedOnBenefit('benefit5')) }} </td>
                    </tr>

                </tbody>
            </table>
        </div>
        </div>
        <br>

        <!-- Optical Benefits Table -->
        <div v-if="entries.length" class="mt-6">
        <div class="overflow-x-auto">
            <table class="w-full border-collapse border border-gray-300 md:table">
                <thead>
                    <tr class="bg-gray-200">
                    <th class="border border-gray-300 p-2" colspan="5">OPTICAL BENEFIT</th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.opticalBenefits.benefit1" class="mt-1 p-2 border rounded w-full">
                            <option v-for="amount in opticalAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.opticalBenefits.benefit2" class="mt-1 p-2 border rounded w-full">
                            <option v-for="amount in opticalAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.opticalBenefits.benefit3" class="mt-1 p-2 border rounded w-full">
                            <option v-for="amount in opticalAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.opticalBenefits.benefit4" class="mt-1 p-2 border rounded w-full">
                            <option v-for="amount in opticalAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.opticalBenefits.benefit5" class="mt-1 p-2 border rounded w-full">
                            <option v-for="amount in opticalAmounts" :key="amount" :value="amount">{{ formatAmount(amount) }}</option>
                        </select>
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="border border-gray-300 p-2 font-bold text-center" colspan="5" style="width:40%">TOTAL OPTICAL PREMIUM</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateOpticalBasedOnBenefit('benefit1')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateOpticalBasedOnBenefit('benefit2')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateOpticalBasedOnBenefit('benefit3')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateOpticalBasedOnBenefit('benefit4')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateOpticalBasedOnBenefit('benefit5')) }} </td>
                    </tr>

                </tbody>
            </table>
        </div>
        </div>
        <br>

        <!-- Femina Benefits Table -->
        <div v-if="entries.length" class="mt-6">
        <div class="overflow-x-auto">
            <table class="w-full border-collapse border border-gray-300 md:table">
                <thead>
                    <tr class="bg-gray-200">
                    <th class="border border-gray-300 p-2" colspan="5">FEMINA BENEFIT</th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.feminaBenefits.benefit1" class="mt-1 p-2 border rounded w-full">
                            <option v-for="benefit in feminaPlusBenefits" :key="benefit" :value="benefit">{{ benefit }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.feminaBenefits.benefit2" class="mt-1 p-2 border rounded w-full">
                            <option v-for="benefit in feminaPlusBenefits" :key="benefit" :value="benefit">{{ benefit }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.feminaBenefits.benefit3" class="mt-1 p-2 border rounded w-full">
                            <option v-for="benefit in feminaPlusBenefits" :key="benefit" :value="benefit">{{ benefit }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.feminaBenefits.benefit4" class="mt-1 p-2 border rounded w-full">
                            <option v-for="benefit in feminaPlusBenefits" :key="benefit" :value="benefit">{{ benefit }}</option>
                        </select>
                    </th>
                    <th class="border border-gray-300 p-2">
                        <select v-model="form.feminaBenefits.benefit5" class="mt-1 p-2 border rounded w-full">
                            <option v-for="benefit in feminaPlusBenefits" :key="benefit" :value="benefit">{{ benefit }}</option>
                        </select>
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="border border-gray-300 p-2 font-bold text-center" colspan="5" style="width:40%">TOTAL FEMINA PREMIUM</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateFeminaBasedOnBenefit('benefit1')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateFeminaBasedOnBenefit('benefit2')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateFeminaBasedOnBenefit('benefit3')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateFeminaBasedOnBenefit('benefit4')) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(calculateFeminaBasedOnBenefit('benefit5')) }} </td>
                    </tr>

                </tbody>
            </table>
        </div>
        </div>
        <br>

        <!-- Total Basic Premium Table -->
        <div v-if="entries.length" class="mt-6">
        <div class="overflow-x-auto">
            <table class="w-full border-collapse border border-gray-300 md:table">
                <tbody>
                    <tr>
                        <td class="border border-gray-300 p-2 font-bold text-center text-blue-800" colspan="5" style="width:40%">TOTAL BASIC PREMIUM</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(benefit1Totals.benefit_total) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(benefit2Totals.benefit_total) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(benefit3Totals.benefit_total) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(benefit4Totals.benefit_total) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(benefit5Totals.benefit_total) }} </td>
                    </tr>
                    <tr>
                        <td class="border border-gray-300 p-2 font-bold text-center text-blue-800" colspan="5" style="width:46%">TL, PHCF & STAMP DUTY</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(feesBenefit1) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(feesBenefit2) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(feesBenefit3) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(feesBenefit4) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(feesBenefit5) }} </td>
                    </tr>
                    <tr>
                        <td class="border border-gray-300 p-2 font-bold text-center text-blue-800" colspan="5" style="width:46%">TOTAL PREMIUM</td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(totalPremiumBenefit1) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(totalPremiumBenefit2) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(totalPremiumBenefit3) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(totalPremiumBenefit4) }} </td>
                        <td class="border border-gray-300 p-2">{{ formatAmount(totalPremiumBenefit5) }} </td>
                    </tr>

                </tbody>
            </table>
        </div>
        </div>
        <br>

    </div>
  </div>
  <!--End of pdf report -->

  <div v-if="entries.length" class="p-6 mx-auto bg-white rounded-lg shadow-md flex justify-around">
    <button @click="clearEntries" type="button" class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">
      Clear Entries
    </button>
    <button @click="printQuote" type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
      Generate Quote
    </button>
    <button @click="backHome" type="button" class="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">
      Back Home
    </button>
  </div>

</template>

<script>
import benefits from '@/data/rates.json';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
  data() {
    return {
      form: {
        memberName: '',
        dob: '',
        gender: 'M',
        relationship: 'Principal',
        inpatientBenefits: {
            benefit1: 500000,
            benefit2: 1000000,
            benefit3: 2000000,
            benefit4: 3000000,
            benefit5: 5000000
        },
        outpatientBenefits: {
            benefit1: 50000,
            benefit2: 75000,
            benefit3: 100000,
            benefit4: 150000,
            benefit5: 200000
        },
        maternityBenefits: {
            benefit1: 50000,
            benefit2: 100000,
            benefit3: 150000,
            benefit4: 200000,
            benefit5: 250000
        },
        dentalBenefits: {
            benefit1: 10000,
            benefit2: 20000,
            benefit3: 30000,
            benefit4: 40000,
            benefit5: 40000
        },
        opticalBenefits: {
            benefit1: 10000,
            benefit2: 20000,
            benefit3: 30000,
            benefit4: 40000,
            benefit5: 40000
        },
        feminaBenefits: {
            benefit1: 'Silver',
            benefit2: 'Gold',
            benefit3: 'Platinum',
            benefit4: 'Platinum',
            benefit5: 'Platinum',
        }

      },
      entries: JSON.parse(localStorage.getItem('entries')) || [],
      benefits,
      logo: require('@/assets/logo.png'), // Importing the logo
      clientDetails: JSON.parse(localStorage.getItem('clientDetails')) ||
      {
        name: this.$route.query.name || '',
        email: this.$route.query.email || '',
        telephone: this.$route.query.phone || '',
       }
    };
  },
  computed: {
    inpatientAmounts() {
      return [500000, 1000000, 2000000, 3000000, 5000000, 7500000, 10000000];
    },
    outpatientAmounts() {
      return [null, 50000, 75000, 100000, 150000, 200000];
    },
    dentalAmounts() {
      return [null, 10000, 20000, 30000, 40000];
    },
    opticalAmounts() {
      return [null, 10000, 20000, 30000, 40000];
    },
    maternityAmounts() {
      return [null, 50000, 100000, 150000, 200000, 250000];
    },
    feminaPlusBenefits() {
      return [null,'Silver', 'Gold', 'Platinum'];
    },
    themeColors() {
      return {
        navy: [0, 0, 139],
        navyDark: [0, 0, 90],
        red: [178, 30, 46],
        lightGray: [240, 243, 248],
        borderGray: [200, 200, 200],
        grayText: [90, 90, 90]
      };
    },
    maxDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = ('0' + (today.getMonth() + 1)).slice(-2);
      const day = ('0' + today.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },

    totalInpatientBenefits() {
        const totals = {
            benefit1: 0,
            benefit2: 0,
            benefit3: 0,
            benefit4: 0,
            benefit5: 0,
        };

        this.entries.forEach(entry => {
            totals.benefit1 += this.calculateInpatientBasedOnBenefit('benefit1', entry) || 0;
            totals.benefit2 += this.calculateInpatientBasedOnBenefit('benefit2', entry) || 0;
            totals.benefit3 += this.calculateInpatientBasedOnBenefit('benefit3', entry) || 0;
            totals.benefit4 += this.calculateInpatientBasedOnBenefit('benefit4', entry) || 0;
            totals.benefit5 += this.calculateInpatientBasedOnBenefit('benefit5', entry) || 0;
        });

        return totals;
    },
    totalOutpatientBenefits() {
        const totals = {
            benefit1: 0,
            benefit2: 0,
            benefit3: 0,
            benefit4: 0,
            benefit5: 0,
        };

        this.entries.forEach(entry => {
            totals.benefit1 += this.calculateOutpatientBasedOnBenefit('benefit1', entry) || 0;
            totals.benefit2 += this.calculateOutpatientBasedOnBenefit('benefit2', entry) || 0;
            totals.benefit3 += this.calculateOutpatientBasedOnBenefit('benefit3', entry) || 0;
            totals.benefit4 += this.calculateOutpatientBasedOnBenefit('benefit4', entry) || 0;
            totals.benefit5 += this.calculateOutpatientBasedOnBenefit('benefit5', entry) || 0;
        });

        return totals;
    },
    benefit1Totals() {
        return this.calculateBenefitTotals('benefit1');
    },
    benefit2Totals() {
        return this.calculateBenefitTotals('benefit2');
    },
    benefit3Totals() {
        return this.calculateBenefitTotals('benefit3');
    },
    benefit4Totals() {
        return this.calculateBenefitTotals('benefit4');
    },
    benefit5Totals() {
        return this.calculateBenefitTotals('benefit5');
    },
    feesBenefit1() {
        return this.calculateFees(this.benefit1Totals, 'benefit1');
    },
    feesBenefit2() {
        return this.calculateFees(this.benefit2Totals, 'benefit2');
    },
    feesBenefit3() {
        return this.calculateFees(this.benefit3Totals, 'benefit3');
    },
    feesBenefit4() {
        return this.calculateFees(this.benefit4Totals, 'benefit4');
    },
    feesBenefit5() {
        return this.calculateFees(this.benefit5Totals, 'benefit5');
    },
    totalPremiumBenefit1() {
        return this.calculateTotalPremium(this.benefit1Totals, this.feesBenefit1);
    },
    totalPremiumBenefit2() {
        return this.calculateTotalPremium(this.benefit2Totals, this.feesBenefit2);
    },
    totalPremiumBenefit3() {
        return this.calculateTotalPremium(this.benefit3Totals, this.feesBenefit3);
    },
    totalPremiumBenefit4() {
        return this.calculateTotalPremium(this.benefit4Totals, this.feesBenefit4);
    },
    totalPremiumBenefit5() {
        return this.calculateTotalPremium(this.benefit5Totals, this.feesBenefit5);
    }

  },
  methods: {
    formatAmount(amount) {
        if (amount === null || amount === undefined) {
            return '-';
        }
        return amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },

    shouldIncludeOption(option) {
      const entries = JSON.parse(localStorage.getItem('entries')) || [];
      return !entries.some(entry => entry.relationship === option);
    },

    calculateInpatientBasedOnBenefit(benefitKey, entry) {
        const benefitAmount = this.form.inpatientBenefits[benefitKey];
        if (benefitAmount === undefined) {
            console.error(`Benefit key '${benefitKey}' not found in inpatientBenefits.`);
            return null;
        }

        const getAgeRangeKey = (age) => {
            if (age <= 20) return "20";
            if (age > 20 && age <= 40) return "40";
            if (age > 40 && age <= 54) return "54";
            if (age > 54 && age <= 65) return "65";
            if (age > 65 && age <= 70) return "70";
            if (age > 70 && age <= 75) return "75";
            if (age > 75 && age <= 80) return "80";
            return null; // Fallback, in case age doesn't match any criteria
        };

        const ageRangeKey = getAgeRangeKey(entry.age);
        if (ageRangeKey) {
            if (entry.relationship === 'Principal') {
                return this.benefits['principal'][ageRangeKey][benefitAmount];
            }

            if (entry.relationship === 'Spouse') {
                return this.benefits['spouse'][ageRangeKey][benefitAmount];
            }
        }

        return this.benefits['spouse'][ageRangeKey][benefitAmount]; // Fallback, in case no conditions are met
    },

    calculateOutpatientBasedOnBenefit(benefitKey, entry) {
        const benefitAmount = this.form.outpatientBenefits[benefitKey];
        if (benefitAmount === undefined) {
            console.error(`Benefit key '${benefitKey}' not found in outpatientBenefits.`);
            return null;
        }
        const getAgeRangeKey = (age) => {
            if (age <= 20) return "20";
            if (age > 20 && age <= 40) return "40";
            if (age > 40 && age <= 54) return "54";
            if (age > 54 && age <= 65) return "65";
            if (age > 65 && age <= 70) return "70";
            if (age > 70 && age <= 75) return "75";
            if (age > 75 && age <= 80) return "80";
            return null; // Fallback, in case age doesn't match any criteria
        };

        const ageRangeKey = getAgeRangeKey(entry.age);
            if (ageRangeKey) {
            return this.benefits['outpatient'][ageRangeKey][benefitAmount];
        }

        return null;
    },

    calculateMaternityBasedOnBenefit(benefitKey) {

        const benefitAmount = this.form.maternityBenefits[benefitKey];
        if (benefitAmount === undefined) {
            console.error(`Benefit key '${benefitKey}' not found in maternityBenefits.`);
            return null;
        }
        return this.benefits['maternity'][benefitAmount];
    },

    calculateDentalBasedOnBenefit(benefitKey) {
        const benefitAmount = this.form.dentalBenefits[benefitKey];
        if (benefitAmount === undefined) {
            console.error(`Benefit key '${benefitKey}' not found in dentalBenefits.`);
            return null;
        }
        return this.benefits['dental'][benefitAmount] * this.entries.length;
    },

    calculateOpticalBasedOnBenefit(benefitKey) {
        const benefitAmount = this.form.opticalBenefits[benefitKey];
        if (benefitAmount === undefined) {
            console.error(`Benefit key '${benefitKey}' not found in opticalBenefits.`);
            return null;
        }
        return this.benefits['optical'][benefitAmount] * this.entries.length;
    },

    calculateFeminaBasedOnBenefit(benefitKey) {
        const benefitAmount = this.form.feminaBenefits[benefitKey];
        if (benefitAmount === undefined) {
            console.error(`Benefit key '${benefitKey}' not found in feminaBenefits.`);
            return null;
        }
        return this.benefits['feminaPlus'][benefitAmount];
    },
    calculateBenefitTotals(benefitKey) {
        const totals = {
            benefit_total: 0,
        };

        // Calculate the once-only benefits
        const maternityTotal = this.calculateMaternityBasedOnBenefit(benefitKey) || 0;
        const dentalTotal = this.calculateDentalBasedOnBenefit(benefitKey) || 0;
        const opticalTotal = this.calculateOpticalBasedOnBenefit(benefitKey) || 0;
        const feminaTotal = this.calculateFeminaBasedOnBenefit(benefitKey) || 0;

        // Loop through entries for Inpatient and Outpatient benefits
        this.entries.forEach(entry => {
            totals.benefit_total +=
                (this.calculateInpatientBasedOnBenefit(benefitKey, entry) || 0) +
                (this.calculateOutpatientBasedOnBenefit(benefitKey, entry) || 0);
        });

        // Add the once-only benefits to the total
        totals.benefit_total += maternityTotal + dentalTotal + opticalTotal + feminaTotal;

        return totals;
    },
    calculateFees(benefitTotals, benefitKey) {
        const benefitTotalAmount = benefitTotals.benefit_total || 0;
        const feminaBenefit = this.form.feminaBenefits[benefitKey];

        const numberOfEntries = this.entries.length;
        const baseFees = 0.0045 * benefitTotalAmount; // 0.45% of total benefits

        // Calculate the additional fees
        let additionalFees = 40 * numberOfEntries;
        if (feminaBenefit) {
            additionalFees += 40;
        }

        return baseFees + additionalFees;
    },
    calculateTotalPremium(benefitTotals, fees) {
        const benefitTotalAmount = benefitTotals.benefit_total || 0;
        return benefitTotalAmount + fees;
    },

    addEntry() {
      const age = this.calculateAge(this.form.dob);
      const entry_id = Date.now();
      const newEntry = { ...this.form, age, entry_id };
      this.entries.push(newEntry);
      localStorage.setItem('entries', JSON.stringify(this.entries));
      this.resetForm();
    },

    deleteEntry(id) {
      this.entries = this.entries.filter(entry => entry.entry_id !== id);
      localStorage.setItem('entries', JSON.stringify(this.entries));
    },
    isDeleteDisabled(relationship) {
      return relationship === 'Principal';
    },
    resetForm() {
    this.form = {
        memberName: '',
        dob: '',
        gender: 'M',
        relationship: 'Principal',
        inpatientBenefits: {
        benefit1: 500000,
        benefit2: 1000000,
        benefit3: 2000000,
        benefit4: 3000000,
        benefit5: 5000000
        },
        outpatientBenefits: {
        benefit1: 50000,
        benefit2: 75000,
        benefit3: 100000,
        benefit4: 150000,
        benefit5: 200000
        },
        maternityBenefits: {
        benefit1: 50000,
        benefit2: 100000,
        benefit3: 150000,
        benefit4: 150000,
        benefit5: 150000
        },
        dentalBenefits: {
        benefit1: 10000,
        benefit2: 20000,
        benefit3: 30000,
        benefit4: 30000,
        benefit5: 30000
        },
        opticalBenefits: {
        benefit1: 10000,
        benefit2: 20000,
        benefit3: 30000,
        benefit4: 30000,
        benefit5: 30000
        },
        feminaBenefits: {
        benefit1: 'Silver',
        benefit2: 'Gold',
        benefit3: 'Platinum',
        benefit4: 'Platinum',
        benefit5: 'Platinum'
        }
    };
    },
    clearEntries() {
      this.entries = [];
      localStorage.removeItem('entries');
    },
    calculateAge(dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },

    drawSectionBar(doc, text, y, margin, contentWidth, opts = {}) {
      const height = opts.height || 7;
      const fill = opts.fill || this.themeColors.navy;
      doc.setFillColor(fill[0], fill[1], fill[2]);
      doc.rect(margin, y, contentWidth, height, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(opts.fontSize || 10);
      doc.text(text, margin + 3, y + height - 2);
      doc.setTextColor(0, 0, 0);
      return y + height + (opts.gap !== undefined ? opts.gap : 5);
    },

    ensureSpace(doc, y, needed, pageHeight, margin) {
      if (y + needed > pageHeight - margin) {
        doc.addPage();
        return margin;
      }
      return y;
    },

    drawBulletList(doc, lines, x, y, maxWidth, pageHeight, margin) {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      doc.setTextColor(40, 40, 40);
      lines.forEach(line => {
        const wrapped = doc.splitTextToSize(`• ${line}`, maxWidth);
        wrapped.forEach(textLine => {
          if (y + 5 > pageHeight - margin) {
            doc.addPage();
            y = margin;
          }
          doc.text(textLine, x, y);
          y += 5;
        });
      });
      doc.setTextColor(0, 0, 0);
      return y;
    },

    addPageNumber(doc, pageNumber, pageHeight, pageWidth, margin) {
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(120, 120, 120);
      doc.text(`Page ${pageNumber}`, pageWidth - margin, pageHeight - 8, { align: 'right' });
      doc.setTextColor(0, 0, 0);
    },

    generateReference() {
      const year = new Date().getFullYear();
      const serial = Math.floor(1000 + Math.random() * 9000);
      return `REF: JPC/${year}/${serial}`;
    },

    drawFooterBlock(doc, y, margin, pageWidth, getDate, reference) {
      doc.setDrawColor(this.themeColors.borderGray[0], this.themeColors.borderGray[1], this.themeColors.borderGray[2]);
      doc.setLineWidth(0.3);
      doc.line(margin, y, pageWidth - margin, y);
      y += 6;

      doc.setFillColor(this.themeColors.navy[0], this.themeColors.navy[1], this.themeColors.navy[2]);
      doc.rect(margin, y - 3, 4, 4, 'F');
      doc.setFillColor(this.themeColors.red[0], this.themeColors.red[1], this.themeColors.red[2]);
      doc.rect(margin + 5, y - 3, 4, 4, 'F');

      doc.setFontSize(8);
      doc.setFont('helvetica', 'italic');
      doc.setTextColor(this.themeColors.grayText[0], this.themeColors.grayText[1], this.themeColors.grayText[2]);
      doc.text(`Quote Issued: ${getDate}`, margin + 12, y);
      doc.text(`Reference: ${reference}`, margin + 12, y + 5);
      doc.text('This quote is valid for 90 days from the date of issue', pageWidth / 2, y, { align: 'center' });
      doc.text('Jamii Plus Comparison Quote', pageWidth - margin, y, { align: 'right' });

      doc.setTextColor(0, 0, 0);
      return y + 10;
    },

    printQuote() {
        const doc = new jsPDF('p', 'mm', 'a4');
        const margin = 14;
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const contentWidth = pageWidth - margin * 2;
        const optionKeys = ['benefit1', 'benefit2', 'benefit3', 'benefit4', 'benefit5'];
        const optionLabels = ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5'];

        const pageFooterHook = (data) => {
          this.addPageNumber(doc, data.pageNumber, pageHeight, pageWidth, margin);
        };

        const currentDate = new Date();
        const timestamp = currentDate.toLocaleString();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = currentDate.getFullYear();
        const getDate = `${day}/${month}/${year}`;
        const reference = this.generateReference();

        // Top bar
        doc.setFillColor(this.themeColors.navy[0], this.themeColors.navy[1], this.themeColors.navy[2]);
        doc.rect(0, 0, pageWidth, 8, 'F');
        doc.setFontSize(7);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(255, 255, 255);
        doc.text(`APA Jamii Plus comparison quotation tool - ${timestamp}`, margin, 5.5);
        doc.setTextColor(0, 0, 0);

        let y = 22;

        // Title
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(18);
        doc.setTextColor(this.themeColors.red[0], this.themeColors.red[1], this.themeColors.red[2]);
        doc.text('JAMII PLUS COMPARISON QUOTE', margin, y);
        doc.setDrawColor(this.themeColors.red[0], this.themeColors.red[1], this.themeColors.red[2]);
        doc.setLineWidth(1);
        doc.line(margin, y + 3, margin + 75, y + 3);
        doc.setTextColor(0, 0, 0);

        // Logo
        doc.addImage(this.logo, 'PNG', pageWidth - margin - 45, 10, 45, 20);

        y += 14;
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.text('Client Name:', margin, y);
        doc.setFont('helvetica', 'normal');
        doc.text(this.clientDetails.name || '-', margin + 32, y);
        y += 6;
        doc.setFont('helvetica', 'bold');
        doc.text('Email:', margin, y);
        doc.setFont('helvetica', 'normal');
        doc.text(this.clientDetails.email || '-', margin + 32, y);
        y += 6;
        doc.setFont('helvetica', 'bold');
        doc.text('Telephone:', margin, y);
        doc.setFont('helvetica', 'normal');
        doc.text(this.clientDetails.phone || this.clientDetails.telephone || '-', margin + 32, y);
        y += 10;

        // Cover Options Overview
        y = this.drawSectionBar(doc, 'COVER OPTIONS OVERVIEW', y, margin, contentWidth);
        autoTable(doc, {
          startY: y,
          head: [['Benefit', ...optionLabels]],
          body: [
            ['Inpatient Limit', ...optionKeys.map(k => this.formatAmount(this.form.inpatientBenefits[k]))],
            ['Outpatient Limit', ...optionKeys.map(k => this.formatAmount(this.form.outpatientBenefits[k]))],
            ['Maternity Limit', ...optionKeys.map(k => this.formatAmount(this.form.maternityBenefits[k]))],
            ['Dental Limit', ...optionKeys.map(k => this.formatAmount(this.form.dentalBenefits[k]))],
            ['Optical Limit', ...optionKeys.map(k => this.formatAmount(this.form.opticalBenefits[k]))],
            ['Femina Plan', ...optionKeys.map(k => this.form.feminaBenefits[k] || '-')]
          ],
          margin: { left: margin, right: margin },
          theme: 'grid',
          styles: { fontSize: 8.5, valign: 'middle', halign: 'center' },
          headStyles: { fillColor: this.themeColors.navy, textColor: 255, halign: 'center' },
          columnStyles: { 0: { halign: 'left', fontStyle: 'bold', cellWidth: 32 } },
          didDrawPage: pageFooterHook
        });
        y = doc.previousAutoTable.finalY + 8;

        // Members table
        y = this.ensureSpace(doc, y, 20, pageHeight, margin);
        y = this.drawSectionBar(doc, 'MEMBERS', y, margin, contentWidth);
        autoTable(doc, {
          startY: y,
          head: [['Member Name', 'DOB', 'Age', 'Gender', 'Relationship']],
          body: this.entries.map(entry => [
            entry.memberName || 'N/A',
            entry.dob || 'N/A',
            entry.age ?? 'N/A',
            entry.gender || 'N/A',
            entry.relationship || 'N/A'
          ]),
          margin: { left: margin, right: margin },
          theme: 'grid',
          styles: { fontSize: 8.5, valign: 'middle', halign: 'center' },
          headStyles: { fillColor: this.themeColors.navy, textColor: 255 },
          columnStyles: { 0: { halign: 'left' } },
          didDrawPage: pageFooterHook
        });
        y = doc.previousAutoTable.finalY + 8;

        // Inpatient premium comparison
        y = this.ensureSpace(doc, y, 20, pageHeight, margin);
        y = this.drawSectionBar(doc, 'INPATIENT PREMIUM COMPARISON', y, margin, contentWidth);
        autoTable(doc, {
          startY: y,
          head: [['Member Name', ...optionLabels]],
          body: [
            ...this.entries.map(entry => [
              entry.memberName || 'N/A',
              ...optionKeys.map(k => this.formatAmount(this.calculateInpatientBasedOnBenefit(k, entry)))
            ]),
            [
              { content: 'TOTAL INPATIENT PREMIUM', styles: { halign: 'center', fontStyle: 'bold' } },
              ...optionKeys.map(k => this.formatAmount(this.totalInpatientBenefits[k]))
            ]
          ],
          margin: { left: margin, right: margin },
          theme: 'grid',
          styles: { fontSize: 8.5, valign: 'middle', halign: 'center' },
          headStyles: { fillColor: this.themeColors.navy, textColor: 255 },
          columnStyles: { 0: { halign: 'left' } },
          didParseCell: (data) => {
            if (data.row.section === 'body' && data.row.index === this.entries.length) {
              data.cell.styles.fillColor = this.themeColors.lightGray;
              data.cell.styles.fontStyle = 'bold';
            }
          },
          didDrawPage: pageFooterHook
        });
        y = doc.previousAutoTable.finalY + 8;

        // Outpatient premium comparison
        y = this.ensureSpace(doc, y, 20, pageHeight, margin);
        y = this.drawSectionBar(doc, 'OUTPATIENT PREMIUM COMPARISON', y, margin, contentWidth);
        autoTable(doc, {
          startY: y,
          head: [['Member Name', ...optionLabels]],
          body: [
            ...this.entries.map(entry => [
              entry.memberName || 'N/A',
              ...optionKeys.map(k => this.formatAmount(this.calculateOutpatientBasedOnBenefit(k, entry)))
            ]),
            [
              { content: 'TOTAL OUTPATIENT PREMIUM', styles: { halign: 'center', fontStyle: 'bold' } },
              ...optionKeys.map(k => this.formatAmount(this.totalOutpatientBenefits[k]))
            ]
          ],
          margin: { left: margin, right: margin },
          theme: 'grid',
          styles: { fontSize: 8.5, valign: 'middle', halign: 'center' },
          headStyles: { fillColor: this.themeColors.navy, textColor: 255 },
          columnStyles: { 0: { halign: 'left' } },
          didParseCell: (data) => {
            if (data.row.section === 'body' && data.row.index === this.entries.length) {
              data.cell.styles.fillColor = this.themeColors.lightGray;
              data.cell.styles.fontStyle = 'bold';
            }
          },
          didDrawPage: pageFooterHook
        });
        y = doc.previousAutoTable.finalY + 8;

        // Once-off benefits comparison (Maternity, Dental, Optical, Femina)
        y = this.ensureSpace(doc, y, 20, pageHeight, margin);
        y = this.drawSectionBar(doc, 'MATERNITY, DENTAL, OPTICAL & FEMINA PLUS COMPARISON', y, margin, contentWidth);
        autoTable(doc, {
          startY: y,
          head: [['Benefit', ...optionLabels]],
          body: [
            ['Maternity Premium', ...optionKeys.map(k => this.formatAmount(this.calculateMaternityBasedOnBenefit(k)))],
            ['Dental Premium', ...optionKeys.map(k => this.formatAmount(this.calculateDentalBasedOnBenefit(k)))],
            ['Optical Premium', ...optionKeys.map(k => this.formatAmount(this.calculateOpticalBasedOnBenefit(k)))],
            ['Femina Plus Premium', ...optionKeys.map(k => this.formatAmount(this.calculateFeminaBasedOnBenefit(k)))]
          ],
          margin: { left: margin, right: margin },
          theme: 'grid',
          styles: { fontSize: 8.5, valign: 'middle', halign: 'center' },
          headStyles: { fillColor: this.themeColors.navy, textColor: 255 },
          columnStyles: { 0: { halign: 'left', fontStyle: 'bold', cellWidth: 45 } },
          didDrawPage: pageFooterHook
        });
        y = doc.previousAutoTable.finalY + 8;

        // Premium summary
        y = this.ensureSpace(doc, y, 20, pageHeight, margin);
        y = this.drawSectionBar(doc, 'PREMIUM SUMMARY', y, margin, contentWidth);
        autoTable(doc, {
          startY: y,
          head: [['Description', ...optionLabels]],
          body: [
            ['Total Basic Premium', this.formatAmount(this.benefit1Totals.benefit_total), this.formatAmount(this.benefit2Totals.benefit_total), this.formatAmount(this.benefit3Totals.benefit_total), this.formatAmount(this.benefit4Totals.benefit_total), this.formatAmount(this.benefit5Totals.benefit_total)],
            ['Levies & Stamp Duty', this.formatAmount(this.feesBenefit1), this.formatAmount(this.feesBenefit2), this.formatAmount(this.feesBenefit3), this.formatAmount(this.feesBenefit4), this.formatAmount(this.feesBenefit5)],
            ['TOTAL PREMIUM', this.formatAmount(this.totalPremiumBenefit1), this.formatAmount(this.totalPremiumBenefit2), this.formatAmount(this.totalPremiumBenefit3), this.formatAmount(this.totalPremiumBenefit4), this.formatAmount(this.totalPremiumBenefit5)]
          ],
          margin: { left: margin, right: margin },
          theme: 'grid',
          styles: { fontSize: 9, valign: 'middle', halign: 'center' },
          headStyles: { fillColor: this.themeColors.navy, textColor: 255 },
          columnStyles: { 0: { halign: 'left', fontStyle: 'bold', cellWidth: 45 } },
          didParseCell: (data) => {
            if (data.row.section === 'body' && data.row.index === 2) {
              data.cell.styles.fillColor = this.themeColors.navyDark;
              data.cell.styles.textColor = 255;
              data.cell.styles.fontStyle = 'bold';
            }
          },
          didDrawPage: pageFooterHook
        });
        y = doc.previousAutoTable.finalY + 10;

        // Terms & Conditions
        y = this.ensureSpace(doc, y, 20, pageHeight, margin);
        y = this.drawSectionBar(doc, 'TERMS & CONDITIONS', y, margin, contentWidth, { fill: this.themeColors.red, gap: 3 });

        y = this.ensureSpace(doc, y, 15, pageHeight, margin);
        y = this.drawSectionBar(doc, 'WAITING PERIODS', y, margin, contentWidth, { height: 6, fontSize: 9 });
        y = this.drawBulletList(doc, [
          'No waiting period for accidents and accidental injuries',
          '30-day waiting period for acute illnesses',
          '3-month waiting period for newly-diagnosed chronic related conditions',
          '90-day waiting period for surgical cases not relating to pre-existing & chronic conditions',
          '10-month waiting period for maternity related conditions',
          '12-month waiting period for pre-existing and chronic related conditions',
          '12-month waiting period for congenital, prematurity & neonatal related conditions',
          '24-month waiting period for organ transplants excluding the cost of obtaining the organ, restricted to kidney, lung, heart, liver & bone marrow transplants',
          '12 months for Fibroid, Hernias, Adenoidectomy, tonsillectomy, and Haemorrhoids related treatment',
          'Any undeclared pre-existing conditions will lead to cancellation of the policy with no refund in premium.'
        ], margin + 2, y, contentWidth - 4, pageHeight, margin);
        y += 4;

        y = this.ensureSpace(doc, y, 15, pageHeight, margin);
        y = this.drawSectionBar(doc, 'DOCUMENTATION REQUIRED', y, margin, contentWidth, { height: 6, fontSize: 9 });
        y = this.drawBulletList(doc, [
          'Duly filled APA medical application form',
          "KYC (ID, KRA PIN, spouse's ID, Birth certificate/notification for the children)",
          'Any applicant who is 60 years and above must submit a current medical report on application for review',
          'Cover will commence after proof of payment is received.'
        ], margin + 2, y, contentWidth - 4, pageHeight, margin);
        y += 4;

        y = this.ensureSpace(doc, y, 15, pageHeight, margin);
        y = this.drawSectionBar(doc, 'PAYMENT OPTIONS', y, margin, contentWidth, { height: 6, fontSize: 9 });
        y = this.drawBulletList(doc, [
          'Bank transfer or Cheque deposits to APA medical bank account at NCBA Account No. 6447560039',
          'Insurance Premium Financing (IPF) – maximum of 4 instalments. IPF documents to be received on or before the renewal date of the policy period.',
          'Mpesa Paybill number 511600, Account: Name of the Principal member'
        ], margin + 2, y, contentWidth - 4, pageHeight, margin);
        y += 6;

        y = this.ensureSpace(doc, y, 10, pageHeight, margin);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);
        doc.text('NB: This quote is valid for only 90 days from the date of issue.', margin, y);
        y += 10;

        // Footer block
        y = this.ensureSpace(doc, y, 20, pageHeight, margin);
        this.drawFooterBlock(doc, y, margin, pageWidth, getDate, reference);

        // Save the PDF
        doc.save('quote.pdf');
        this.saveReport();
    },

    // Helper function to format currency
    formatCurrency(value) {
        return new Intl.NumberFormat('en-KE', { style: 'currency', currency: 'KES' }).format(value);
    },

   // this.clearEntries();

    backHome() {
      this.entries = [];
      localStorage.removeItem('entries');
      this.$router.push('/');
    },

    saveReport() {
      const report = {
        clientName: this.clientDetails.name,
        email: this.clientDetails.email,
        phone: this.clientDetails.phone,
        numberOfEntries: this.entries.length,
        totalPremiumOptions: [
          this.totalPremiumBenefit1,
          this.totalPremiumBenefit2,
          this.totalPremiumBenefit3,
          this.totalPremiumBenefit4,
          this.totalPremiumBenefit5,
        ].map(total => (total || 0).toFixed(2)),
      };
      // eslint-disable-next-line
      const reportJson = JSON.stringify(report);
      // Logic to save the reportJson to a file or server
    },


  }
};
</script>

<style scoped>
/* Add any additional styling here */
</style>
